import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/login'),
      meta: {
        title: '菲斯曼'
      }
    },
    {
      path: '/verification',
      name: 'verification',
      component: () => import('@/components/verification'),
      meta: {
        title: '菲斯曼'
      }
    }
  ]
})

router.afterEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js